import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Observable } from 'rxjs';
import { WorkshopJobTemplate } from 'src/app/models/workshop-job-template';

@Injectable()
export class WorkshopJobTemplateService {
  path = `workshop-jobs/templates`;
  constructor(private http: ApiClient) {}

  getAll() {
    return this.http.get<WorkshopJobTemplate[]>(this.path);
  }

  get(id: number) {
    return this.http.get<WorkshopJobTemplate>(`${this.path}/${id}`);
  }

  update(id: number, attributes) {
    return this.http.put(`${this.path}/${id}`, attributes);
  }

  create(attributes: Partial<WorkshopJobTemplate>) {
    return this.http.post<WorkshopJobTemplate>(this.path, attributes);
  }
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.path}/${id}`);
  }
}
